import { Component, inject } from "@angular/core"
import { TourService } from "../../tour/tour.service"
import { TourScrollToElementComponent } from "../../tour/tour-scroll-to-element.component"
import { IntroAnchor } from "../../tour/tour.model"

@Component({
  imports: [
    TourScrollToElementComponent,
  ],
  standalone: true,
  template: `
    <div class="absolute left-0 right-0 m-auto text-2xl font-semibold p-2 max-w-[400px] -top-8 align-center text-[#fafafa]">
      <e2e-tour-scroll-to-element [elementName]="IntroAnchor.TOUR_CTA"/>
      <div
        class="row justify-center rounded-full p-2 cursor-pointer bg-black"
        (click)="setShowTour(true)"
      >
        <i class="pi pi-volume-up text-3xl"></i>
        Take the virtual tour
      </div>
    </div>
  `,
  selector: "e2e-intro-virtual-tour-cta",
})
export class IntroVirtualTourCtaComponent {
  private tourService = inject(TourService)

  setShowTour(showTour: boolean) {
    this.tourService.setShowTour(showTour)
  }

  protected readonly IntroAnchor = IntroAnchor
}
